<h1>Import Excel - Cartouches</h1>
@if (error) {
  <div class="error">{{ error }}</div>
}
@if (success) {
  <div class="success">{{ success }}</div>
}
<form (submit)="$event.preventDefault(); onImport()">
  <label for="file">Fichier Excel :</label>
  <input type="file" id="file" (change)="onFileChange($event)" accept=".xlsx,.xls" />
  <button type="submit" [disabled]="isLoading || !file">
    {{ isLoading ? 'Import en cours...' : 'Importer' }}
  </button>
</form>

@if (isLoading) {
  <div class="loading-indicator" role="status" aria-live="polite" aria-label="Import en cours">
    <div class="loading-gif"></div>
    <span>Import du fichier en cours...</span>
  </div>
}

@if (!isLoading && results.length > 0) {
  <section>
    <h2>Détail des erreurs</h2>
    @if (results.some(result => result.status === 'error')) {
      <ul>
        @for (result of results; track $index) {
          @if (result.status === 'error') {
            <li>
              <strong>{{ result.nom }}</strong> : {{ result.message || 'Erreur inconnue' }}
            </li>
          }
        }
      </ul>
    } @else {
      <p>Aucune erreur sur les cartouches importées.</p>
    }
  </section>
}

